import React, {useEffect, useLayoutEffect, useState} from 'react';
import {Container, WelcomeTitle, Wrap,} from "./styles";
import Modal from "src/interface/modal/Modal";
import LicenceModal from "./components/LicenceModal";
import PolicyModal from "./components/PolicyModal";
import {Url} from "finhelper";
import {tgBotLink} from "#app/interface/cabinet/header/Header";

// @TODO уточнить типы
interface MainPageProps {
    handleTitle: (title: string) => void;
}

const MainPage: React.FC<MainPageProps> = (props) => {
    const [linkTg, setLink] = useState<string>(tgBotLink);
    const [isScrolled, setScrolled] = useState<boolean>(false);
    const [isLicenceModalOpen, setLicenceModalOpen] = useState<boolean>(false);
    const [isPolicyModalOpen, setPolicyModalOpen] = useState<boolean>(false);

    useLayoutEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 0) {
                setScrolled(true);
            } else if (window.pageYOffset === 0) {
                setScrolled(false);
            }
        };

        document.addEventListener("scroll", handleScroll);

        const url = Url.getCurrentUrl();

        if (url === "/agreement") {
            Modal.handleShow();
            setLicenceModalOpen(true);
        }
        if (url === "/policy") {
            Modal.handleShow();
            setPolicyModalOpen(true);
        }
    }, []);

    useEffect(() => {
        props.handleTitle("BlackSwan");
    }, []);

    return (
        <Container>
            <Wrap className="wrap">
                <WelcomeTitle className="welcome-title">
                    <h1>Кабинет технической поддержки</h1>
                </WelcomeTitle>
            </Wrap>
            <LicenceModal
                show={isLicenceModalOpen}
                onClose={() => {
                    setLicenceModalOpen(false);
                }}
            />
            <PolicyModal
                show={isPolicyModalOpen}
                onClose={() => {
                    setPolicyModalOpen(false);
                }}
            />
        </Container>
    );
};

export default MainPage;











